import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const AGBPage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#0B0F14', color: '#E6EDF3' }}>
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-blue-400 hover:text-blue-300 mb-8"
        >
          <ArrowLeft size={20} />
          Zurück zur Startseite
        </Link>

        <h1 className="text-4xl font-bold mb-8" style={{ color: '#1EA0E6' }}>
          Allgemeine Geschäftsbedingungen (AGB)
        </h1>

        <div className="space-y-8 text-gray-300">
          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              1. Geltungsbereich
            </h2>
            <p className="mb-4">
              Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge über die Nutzung 
              der Plattform "Carcortex-ai" (nachfolgend "Plattform"), die zwischen dem Betreiber
            </p>
            <div className="ml-4 mb-4">
              <p>Andreas Trenter</p>
              <p>STR-Performance</p>
              <p>Dorfweg 8, 4718 Holderbank, Schweiz</p>
            </div>
            <p className="mb-4">
              (nachfolgend "Anbieter") und dem Nutzer (nachfolgend "Nutzer") geschlossen werden.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              2. Leistungsbeschreibung
            </h2>
            <h3 className="text-xl font-semibold mb-3 mt-6">2.1 Art der Dienstleistung</h3>
            <p className="mb-4">
              Die Plattform bietet eine KI-gestützte Diagnose-Hilfe für Fahrzeugprobleme. Die 
              bereitgestellten Informationen und Vorschläge dienen ausschließlich als 
              <strong> UNTERSTÜTZUNG und ORIENTIERUNGSHILFE</strong>.
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6" style={{ color: '#FFA500' }}>
              2.2 WICHTIGER HAFTUNGSAUSSCHLUSS
            </h3>
            <div className="bg-red-900 bg-opacity-20 border-2 border-red-500 p-6 rounded-lg mb-4">
              <p className="font-bold mb-4 text-lg" style={{ color: '#FF6B6B' }}>
                KEINE GARANTIE FÜR RICHTIGKEIT - KEINE HAFTUNG FÜR SCHÄDEN
              </p>
              <ul className="list-disc ml-6 space-y-3">
                <li>
                  Die Plattform erstellt <strong>keine professionelle Fahrzeugdiagnose</strong> und 
                  ersetzt NICHT die Diagnose durch eine qualifizierte Fachwerkstatt.
                </li>
                <li>
                  Die bereitgestellten Diagnose-Vorschläge sind <strong>allgemeine Hilfestellungen</strong> 
                  ohne Gewähr für Richtigkeit, Vollständigkeit oder Aktualität.
                </li>
                <li>
                  Die Plattform enthält <strong>KEINE herstellerspezifischen Diagnosedaten</strong> und 
                  kann fahrzeugindividuelle Besonderheiten nicht berücksichtigen.
                </li>
                <li>
                  Jede Durchführung von Reparaturen oder diagnostischen Maßnahmen erfolgt 
                  <strong> ausschließlich auf eigene Verantwortung und eigenes Risiko</strong> des Nutzers.
                </li>
                <li>
                  Der Anbieter übernimmt <strong>keinerlei Haftung</strong> für Schäden jeglicher Art, 
                  die durch die Nutzung der Plattform oder die Befolgung der bereitgestellten Vorschläge 
                  entstehen.
                </li>
              </ul>
            </div>

            <h3 className="text-xl font-semibold mb-3 mt-6">2.3 Ausschluss von Gewährleistung</h3>
            <p className="mb-4">
              Der Anbieter gewährleistet nicht, dass:
            </p>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li>Die bereitgestellten Diagnose-Vorschläge korrekt oder vollständig sind</li>
              <li>Die vorgeschlagenen Reparaturmaßnahmen zum gewünschten Erfolg führen</li>
              <li>Die Informationen auf dem neuesten Stand der Technik sind</li>
              <li>Die Plattform jederzeit verfügbar und fehlerfrei ist</li>
              <li>Daten unterbrechungsfrei übertragen werden</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3 mt-6">2.4 Empfehlung</h3>
            <p className="mb-4 font-semibold" style={{ color: '#FFA500' }}>
              Der Anbieter empfiehlt ausdrücklich:
            </p>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li>
                Bei sicherheitskritischen Systemen (Bremsen, Lenkung, Airbags) IMMER eine Fachwerkstatt 
                zu konsultieren
              </li>
              <li>
                Vor jeder Reparatur die Diagnose durch einen Fachmann überprüfen zu lassen
              </li>
              <li>
                Herstellervorgaben und gesetzliche Vorschriften zu beachten
              </li>
              <li>
                Bei Unsicherheit keine Eigenreparaturen durchzuführen
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              2.5 Zusätzliche Dienste
            </h2>
            
            <h3 className="text-xl font-semibold mb-3 mt-6">2.5.1 Fahrzeugdaten-Bibliothek</h3>
            <div className="bg-yellow-900 bg-opacity-20 border-2 border-yellow-500 p-6 rounded-lg mb-6">
              <p className="font-bold mb-4 text-lg" style={{ color: '#F59E0B' }}>
                ⚠️ WICHTIGER HINWEIS ZUR FAHRZEUGDATEN-BIBLIOTHEK
              </p>
              <ul className="list-disc ml-6 space-y-3">
                <li>
                  Die in der Fahrzeugdaten-Bibliothek bereitgestellten technischen Spezifikationen werden durch 
                  <strong> automatisierte Web-Recherche und KI-Extraktion</strong> gesammelt.
                </li>
                <li>
                  Diese Daten stammen <strong>NICHT direkt von Fahrzeugherstellern</strong> und sind keine 
                  offiziellen Herstellerangaben.
                </li>
                <li>
                  Trotz sorgfältiger Datenprüfung durch mehrere KI-Systeme können die Daten 
                  <strong> Fehler, Ungenauigkeiten oder Lücken</strong> enthalten.
                </li>
                <li>
                  Die Daten dienen ausschließlich als <strong>Orientierungshilfe</strong> und ersetzen NICHT 
                  die offiziellen Werkstatthandbücher oder Herstellerangaben.
                </li>
                <li>
                  Bei sicherheitsrelevanten Arbeiten (Bremsen, Lenkung, Motor) sind IMMER die 
                  <strong> offiziellen Herstellerdaten</strong> zu verwenden.
                </li>
                <li>
                  Der Anbieter übernimmt <strong>keine Gewähr für Richtigkeit, Vollständigkeit oder Aktualität</strong> 
                  der in der Bibliothek bereitgestellten technischen Daten.
                </li>
                <li>
                  Jede Nutzung der Daten erfolgt auf <strong>eigenes Risiko</strong> des Nutzers.
                </li>
              </ul>
            </div>

            <h3 className="text-xl font-semibold mb-3 mt-6">2.5.2 OBD-Agent Software</h3>
            <p className="mb-4">
              Die Plattform bietet eine OBD-Agent-Software zum Download für Windows, macOS, Linux und Android an. 
              Diese Software dient zum Auslesen von Fahrzeugdaten über OBD-II-Schnittstellen.
            </p>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li>Die Software wird "wie besehen" bereitgestellt ohne Gewährleistung</li>
              <li>Der Anbieter haftet nicht für Schäden am Fahrzeug durch Verwendung der Software</li>
              <li>Die Nutzung erfordert einen kompatiblen OBD-II-Dongle (nicht im Lieferumfang enthalten)</li>
              <li>Die Software darf nur am eigenen Fahrzeug oder mit ausdrücklicher Erlaubnis des Fahrzeughalters verwendet werden</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3 mt-6">2.5.3 Empfehlungsprogramm</h3>
            <p className="mb-4">
              Die Plattform bietet ein Empfehlungsprogramm an, bei dem Nutzer Credits für erfolgreiche Empfehlungen erhalten können.
            </p>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li>Credits werden nur bei erfolgreichen zahlungspflichtigen Abonnements vergeben</li>
              <li>Die Höhe der Credits kann vom Anbieter jederzeit angepasst werden</li>
              <li>Credits sind nicht auszahlbar und können nur für Abonnementverlängerungen oder Upgrades verwendet werden</li>
              <li>Credits verfallen nicht, solange das Konto aktiv ist</li>
              <li>Bei Kündigung des Kontos verfallen alle Credits ohne Erstattungsanspruch</li>
              <li>Der Anbieter behält sich vor, missbräuchliche Nutzung des Empfehlungsprogramms (z.B. Fake-Accounts) zu unterbinden und Credits zu entziehen</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3 mt-6">2.5.4 Flottenmanagement-System (FMS)</h3>
            <p className="mb-4">
              Die FMS-Funktionen ermöglichen die Verwaltung von Fahrzeugflotten, Fahrern und Wartungsplänen.
            </p>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li>Die Anzahl verwaltbarer Fahrzeuge richtet sich nach dem gebuchten Plan</li>
              <li>Wartungserinnerungen sind unverbindliche Hinweise ohne Gewährleistung</li>
              <li>Der Anbieter haftet nicht für versäumte Wartungen oder daraus resultierende Schäden</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              3. Vertragsschluss und Registrierung
            </h2>
            <h3 className="text-xl font-semibold mb-3 mt-6">3.1 Registrierung</h3>
            <p className="mb-4">
              Die Nutzung der Plattform erfordert eine Registrierung. Mit der Registrierung gibt der 
              Nutzer ein verbindliches Angebot zum Abschluss eines Nutzungsvertrages ab. Der Vertrag 
              kommt mit der Bestätigung durch den Anbieter (Bestätigungs-E-Mail) zustande.
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">3.2 Voraussetzungen</h3>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li>Der Nutzer muss volljährig (mindestens 18 Jahre alt) sein</li>
              <li>Der Nutzer muss wahrheitsgemäße Angaben machen</li>
              <li>Pro Person ist nur ein Account zulässig</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              4. Preise und Zahlung
            </h2>
            <h3 className="text-xl font-semibold mb-3 mt-6">4.1 Preise</h3>
            <p className="mb-4">
              Die Preise für die Nutzung der Plattform ergeben sich aus der Preisübersicht auf der Website. 
              Alle Preise verstehen sich als Bruttopreise inklusive der gesetzlichen Mehrwertsteuer.
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">4.2 Zahlung</h3>
            <p className="mb-4">
              Die Zahlung erfolgt über den Zahlungsdienstleister Stripe. Es gelten die 
              <a href="https://stripe.com/de/legal" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 underline ml-1">
                AGB von Stripe
              </a>.
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">4.3 Abonnements</h3>
            <p className="mb-4">
              Bei Abonnements erfolgt die Abrechnung im Voraus für den jeweiligen Abrechnungszeitraum. 
              Das Abonnement verlängert sich automatisch, wenn es nicht vor Ablauf gekündigt wird.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              5. Widerrufsrecht
            </h2>
            <p className="mb-4">
              Verbrauchern steht ein gesetzliches Widerrufsrecht zu:
            </p>

            <div className="bg-gray-800 p-6 rounded-lg mb-4">
              <h3 className="text-xl font-semibold mb-3">Widerrufsbelehrung</h3>
              
              <p className="mb-4 font-semibold">Widerrufsrecht</p>
              <p className="mb-4">
                Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu 
                widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses.
              </p>

              <p className="mb-4">
                Um Ihr Widerrufsrecht auszuüben, müssen Sie uns
              </p>
              <div className="ml-4 mb-4">
                <p>Andreas Trenter, STR-Performance</p>
                <p>Dorfweg 8, 4718 Holderbank, Schweiz</p>
                <p>E-Mail: support@carcortex-ai.com</p>
              </div>
              <p className="mb-4">
                mittels einer eindeutigen Erklärung (z.B. ein mit der Post versandter Brief oder E-Mail) 
                über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren.
              </p>

              <p className="mb-4 font-semibold">Folgen des Widerrufs</p>
              <p className="mb-4">
                Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen 
                erhalten haben, unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, 
                an dem die Mitteilung über Ihren Widerruf bei uns eingegangen ist.
              </p>

              <p className="mb-4 font-semibold">Vorzeitiges Erlöschen des Widerrufsrechts</p>
              <p className="mb-4">
                Das Widerrufsrecht erlischt bei einem Vertrag über die Erbringung von Dienstleistungen, 
                wenn der Anbieter die Dienstleistung vollständig erbracht hat und mit der Ausführung der 
                Dienstleistung erst begonnen hat, nachdem der Verbraucher dazu seine ausdrückliche 
                Zustimmung gegeben hat und gleichzeitig seine Kenntnis davon bestätigt hat, dass er sein 
                Widerrufsrecht bei vollständiger Vertragserfüllung verliert.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              6. Keine Rückerstattung nach Zahlungsabwicklung
            </h2>
            <div className="bg-red-900 bg-opacity-20 border-2 border-red-500 p-6 rounded-lg mb-4">
              <p className="font-bold mb-4 text-lg" style={{ color: '#FF6B6B' }}>
                ⚠️ WICHTIG: KEINE RÜCKERSTATTUNG
              </p>
              <ul className="list-disc ml-6 space-y-3">
                <li>
                  Sobald ein kostenpflichtiger Plan <strong>erfolgreich bezahlt und aktiviert</strong> wurde, 
                  ist <strong>keine Rückerstattung</strong> möglich.
                </li>
                <li>
                  Dies gilt für alle Zahlungsarten (Einmalzahlung, monatliche und jährliche Abonnements).
                </li>
                <li>
                  Der Nutzer erklärt sich bei der Buchung ausdrücklich damit einverstanden, dass der 
                  Zugang zu den digitalen Inhalten sofort nach Zahlungseingang gewährt wird und 
                  verzichtet damit auf sein Widerrufsrecht gemäß § 356 Abs. 5 BGB bzw. Art. 16 lit. m der 
                  Richtlinie 2011/83/EU.
                </li>
                <li>
                  Bei wiederkehrenden Zahlungen (Abonnements) kann der Nutzer das Abonnement jederzeit 
                  zum Ende des aktuellen Abrechnungszeitraums kündigen. Eine Erstattung des bereits 
                  bezahlten Zeitraums erfolgt nicht.
                </li>
                <li>
                  Ausnahme: Bei nachweislich technischen Mängeln, die eine Nutzung der Plattform 
                  vollständig und dauerhaft unmöglich machen und die vom Anbieter nicht behoben werden 
                  können, kann nach Einzelfallprüfung eine anteilige Erstattung erfolgen.
                </li>
              </ul>
            </div>
            <p className="mb-4">
              Durch Abschluss eines kostenpflichtigen Plans bestätigt der Nutzer, diese 
              Rückerstattungsrichtlinie gelesen und akzeptiert zu haben.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              7. Pflichten des Nutzers
            </h2>
            <p className="mb-4">Der Nutzer verpflichtet sich:</p>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li>Die Plattform nur im Rahmen der gesetzlichen Bestimmungen zu nutzen</li>
              <li>Seine Zugangsdaten geheim zu halten und nicht an Dritte weiterzugeben</li>
              <li>Keine rechtswidrigen Inhalte hochzuladen</li>
              <li>Keine Schadsoftware oder schädlichen Code einzuschleusen</li>
              <li>Die Plattform nicht für kommerzielle Zwecke Dritter zu nutzen</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              7. Haftungsbeschränkung
            </h2>
            
            <h3 className="text-xl font-semibold mb-3 mt-6">7.1 Allgemeine Haftungsbeschränkung</h3>
            <p className="mb-4">
              Der Anbieter haftet nur bei Vorsatz und grober Fahrlässigkeit. Bei leichter Fahrlässigkeit 
              haftet der Anbieter nur:
            </p>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li>Bei Verletzung des Lebens, des Körpers oder der Gesundheit</li>
              <li>Bei Verletzung wesentlicher Vertragspflichten</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3 mt-6">7.2 Ausschluss für Diagnose-Vorschläge und Fahrzeugdaten</h3>
            <p className="mb-4 font-semibold" style={{ color: '#FFA500' }}>
              Für Schäden, die durch die Befolgung von Diagnose-Vorschlägen, Reparaturhinweisen oder 
              die Nutzung von Daten aus der Fahrzeugdaten-Bibliothek entstehen, haftet der Anbieter NICHT. 
              Dies gilt insbesondere für:
            </p>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li>Schäden am Fahrzeug (Sachschäden)</li>
              <li>Folgeschäden durch fehlerhafte Diagnosen, Reparaturen oder technische Daten</li>
              <li>Schäden durch falsche oder ungenaue Spezifikationen aus der Fahrzeugdaten-Bibliothek</li>
              <li>Verlust von Garantie- oder Gewährleistungsansprüchen</li>
              <li>Personenschäden durch unsachgemäße Reparaturen</li>
              <li>Verstöße gegen gesetzliche Vorschriften oder Herstellervorgaben</li>
              <li>Schäden durch Anwendung fehlerhafter Drehmomente, Toleranzwerte oder Sollwerte</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3 mt-6">7.3 Datenverlust</h3>
            <p className="mb-4">
              Der Anbieter haftet nicht für Datenverlust, es sei denn, dieser wäre durch angemessene 
              Datensicherungsmaßnahmen durch den Nutzer vermeidbar gewesen.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              8. Kündigung
            </h2>
            <h3 className="text-xl font-semibold mb-3 mt-6">8.1 Ordentliche Kündigung</h3>
            <p className="mb-4">
              Der Nutzer kann sein Abonnement jederzeit zum Ende des laufenden Abrechnungszeitraums 
              kündigen. Die Kündigung muss in Textform (E-Mail) erfolgen.
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">8.2 Außerordentliche Kündigung</h3>
            <p className="mb-4">
              Der Anbieter kann den Vertrag aus wichtigem Grund fristlos kündigen, insbesondere bei:
            </p>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li>Verstoß gegen diese AGB</li>
              <li>Zahlungsverzug von mehr als 14 Tagen</li>
              <li>Missbrauch der Plattform</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              9. Urheberrecht und Nutzungsrechte
            </h2>
            <p className="mb-4">
              Alle Inhalte der Plattform (Texte, Bilder, Grafiken, Software) sind urheberrechtlich 
              geschützt. Der Nutzer erhält ein einfaches, nicht übertragbares Nutzungsrecht für die 
              Dauer des Vertrages.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              10. Datenschutz
            </h2>
            <p className="mb-4">
              Der Anbieter verpflichtet sich, alle personenbezogenen Daten des Nutzers gemäß den 
              geltenden Datenschutzbestimmungen zu verarbeiten. Details siehe 
              <Link to="/datenschutz" className="text-blue-400 hover:text-blue-300 underline ml-1">
                Datenschutzerklärung
              </Link>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              11. Schlussbestimmungen
            </h2>
            
            <h3 className="text-xl font-semibold mb-3 mt-6">11.1 Änderungen der AGB</h3>
            <p className="mb-4">
              Der Anbieter behält sich vor, diese AGB mit Wirkung für die Zukunft zu ändern. 
              Änderungen werden dem Nutzer per E-Mail mitgeteilt. Widerspricht der Nutzer nicht 
              innerhalb von 4 Wochen, gelten die geänderten AGB als angenommen.
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">11.2 Anwendbares Recht</h3>
            <p className="mb-4">
              Es gilt Schweizer Recht unter Ausschluss des UN-Kaufrechts.
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">11.3 Gerichtsstand</h3>
            <p className="mb-4">
              Gerichtsstand für alle Streitigkeiten ist, soweit gesetzlich zulässig, der Sitz des Anbieters.
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">11.4 Salvatorische Klausel</h3>
            <p className="mb-4">
              Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit 
              der übrigen Bestimmungen davon unberührt.
            </p>
          </section>

          <div className="mt-12 pt-8 border-t" style={{ borderColor: '#1F2937' }}>
            <p className="text-sm text-gray-400">
              Letzte Aktualisierung: {new Date().toLocaleDateString('de-DE')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AGBPage;
